export const filterFalsy = <T>(arr: T[]): T[] => arr.filter((i) => Boolean(i));
